<template>
  <div >


    <p>
        <label :for="id">
          <input @change="visibility" v-model="checked" :value="checkedState" type="checkbox" :id="id" />
          <span>{{showContent?hideText:text }}</span>
        </label>

    </p>

    <slot v-if="showContent"></slot>
  </div>
</template>

<script>
export default {
  props: {
    styles: {
      type: Object,
      required: false,
      default: function() {
        return {
          "btn-primary": true,
          "btn--block": true,
          "btn--text": true
        };
      }
    },
    icon: {
      type: String,
      required: false,
      default: "fa fa-eye"
    },
    hideIcon: {
      type: String,
      required: false,
      default: "fa fa-eye-slash"
    },
    hideText: {
      type: String,
      required: false,
      default: ""
    },
    id: {
            type: String,
            required: true
    },
    shown: {
      type: Boolean,
      required: false,
      default: false
    },
    checkedState: {
      type: Number,
      required: false,
      default: false

    },
    text: {
      type: String,
      required: false,
      default: ""
    }
  },
  methods:{
        
       visibility(){
           if( this.showContent ==1){

                this.showContent = false
           }else{
               this.showContent = true

           }
           
          // console.log(this.checkedState)
      }




  },
  data: function() {
    return {
      showContent: this.shown,
      checked: this.checkedState == 1?(1):(0),
      
    };
  },
    mounted() {
        if(this.checkedState==1){
            this.visibility();

        }else{


        }
       
   
    
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/ExpandableContentCheckbox.vue